// Vendor
import { EventEmitter } from '@angular/core';
import { FILTER, TRANSFORM } from 'ConverterApp/constants';
// Services
import { ConverterService } from 'ConverterApp/services/converter.service';
// Components
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "ConverterApp/services/converter.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
const _c0 = ["confirmationModal"];
const _c1 = (a0, a1) => ({ "show": a0, "active": a1 });
const _c2 = a0 => ({ "show": a0 });
function ConvertModalComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("click", function ConvertModalComponent_div_23_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.toggleShowDiff()); });
    i0.ɵɵelementStart(1, "span", 19);
    i0.ɵɵtext(2, "View affected metrics and/or data");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r2.showDiff, ctx_r2.showDiff));
} }
function ConvertModalComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 22)(2, "div", 23)(3, "div", 24)(4, "div", 25)(5, "div", 26);
    i0.ɵɵtext(6, "Metrics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "ul", 27)(8, "li");
    i0.ɵɵtext(9, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(10, "br");
    i0.ɵɵtext(11, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "li");
    i0.ɵɵtext(13, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(14, "br");
    i0.ɵɵtext(15, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "li");
    i0.ɵɵtext(17, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(18, "br");
    i0.ɵɵtext(19, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "li");
    i0.ɵɵtext(21, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(22, "br");
    i0.ɵɵtext(23, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(24, "div", 25)(25, "div", 26);
    i0.ɵɵtext(26, "Scoring Models");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "ul", 27)(28, "li");
    i0.ɵɵtext(29, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "li");
    i0.ɵɵtext(31, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "li");
    i0.ɵɵtext(33, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "li");
    i0.ɵɵtext(35, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "li");
    i0.ɵɵtext(37, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "li");
    i0.ɵɵtext(39, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "li");
    i0.ɵɵtext(41, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "li");
    i0.ɵɵtext(43, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "li");
    i0.ɵɵtext(45, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "li");
    i0.ɵɵtext(47, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(48, "div", 25)(49, "div", 26);
    i0.ɵɵtext(50, "Metrics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(51, "ul", 27)(52, "li");
    i0.ɵɵtext(53, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(54, "br");
    i0.ɵɵtext(55, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(56, "li");
    i0.ɵɵtext(57, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(58, "br");
    i0.ɵɵtext(59, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(60, "li");
    i0.ɵɵtext(61, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(62, "br");
    i0.ɵɵtext(63, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(64, "li");
    i0.ɵɵtext(65, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(66, "br");
    i0.ɵɵtext(67, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "li");
    i0.ɵɵtext(69, "Unavailable Metric: Alpha vs. Category ");
    i0.ɵɵelement(70, "br");
    i0.ɵɵtext(71, "Comparable Metric: Alpha vs. Peer Group ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(72, "div", 25)(73, "div", 26);
    i0.ɵɵtext(74, "Scoring Models");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "ul", 27)(76, "li");
    i0.ɵɵtext(77, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "li");
    i0.ɵɵtext(79, "Unavailable Data: Relative Performance (Funds)");
    i0.ɵɵelementEnd()()()()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2, ctx_r2.showDiff));
} }
export class ConvertModalComponent {
    constructor(converterService) {
        this.converterService = converterService;
        /**
         * Boolean input, indicating if an action is required or not. Default to `true`.
         */
        this.requiresAction = true;
        /**
         * Object input, with the diff object if it has already been retrieved. Default to `null`.
         *
         * If the object is null, this component will try to retrieve the diff object from the endpoint, but it is here as
         * an argument in case it has been retrieved earlier in a parent component.
         */
        this.assetDiff = null;
        /**
         * String input, with the error message if we already received. Default to `null`.
         */
        this.error = undefined;
        // Component outputs
        /**
         * Event emitted when the asset has been converted.
         *
         * The argument is the ID of the asset returned by the endpoint, which will be a different ID if `createCopy` is
         * `true`.
         */
        this.converted = new EventEmitter();
        /**
         * Event emitted when no action has been taken.
         */
        this.canceled = new EventEmitter();
        // Constants
        this.FILTER = FILTER;
        this.TRANSFORM = TRANSFORM;
        // Modal data input
        this.createCopy = false;
        this.conversionMode = TRANSFORM;
        // Internal data
        this.convertModalOpen = false;
        this.confirmationModalOpen = false;
        this.showDiff = false;
        this.loading = false;
        // Handlers
        this.closeConvertModalHandler = () => {
            if (this.requiresAction)
                return;
            this.convertModalOpen = false;
            this.canceled.emit();
        };
        this.submitConvertModalHandler = () => {
            if (this.createCopy) {
                this.submit();
                return;
            }
            this.convertModalOpen = false;
            this.confirmationModalOpen = true;
        };
        this.closeConfirmationModalHandler = () => {
            this.confirmationModalOpen = false;
            this.convertModalOpen = true;
        };
        this.submitConfirmationModalHandler = () => {
            this.confirmationModalOpen = false;
            this.convertModalOpen = true;
            this.submit();
        };
        this.setConversionMode = (mode) => {
            this.conversionMode = mode;
        };
        this.toggleCreateCopy = () => {
            this.createCopy = !this.createCopy;
        };
        this.toggleShowDiff = () => {
            this.showDiff = !this.showDiff;
        };
        // Logic
        this.reset = () => {
            this.createCopy = false;
            this.conversionMode = TRANSFORM;
            this.loading = false;
            this.error = undefined;
        };
        this.submit = () => {
            this.error = undefined;
            this.loading = true;
            // send request
            const params = { in_place: !this.createCopy, mode: this.conversionMode };
            window.pendoTrack('Submit Converter Modal', {
                assetType: this.assetType,
                assetId: this.assetId,
                createCopy: this.createCopy,
                mode: this.conversionMode,
            });
            this.converterService.convert(this.assetType, this.assetId, params).subscribe({
                next: (response) => {
                    this.loading = false;
                    this.convertModalOpen = false;
                    this.converted.emit(response.body.assetId);
                },
                error: (response) => {
                    this.loading = false;
                    this.error = response.error.error;
                },
            });
        };
        // Public methods
        this.openModal = () => {
            if (this.convertModalOpen)
                return;
            window.pendoTrack('Open Converter Modal', {
                assetType: this.assetType,
                assetId: this.assetId,
            });
            this.reset();
            this.convertModalOpen = true;
        };
    }
}
ConvertModalComponent.ɵfac = function ConvertModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConvertModalComponent)(i0.ɵɵdirectiveInject(i1.ConverterService)); };
ConvertModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConvertModalComponent, selectors: [["ycn-convert-modal"]], viewQuery: function ConvertModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmModal = _t.first);
    } }, inputs: { assetType: "assetType", assetId: "assetId", requiresAction: "requiresAction", assetDiff: "assetDiff", error: "error" }, outputs: { converted: "converted", canceled: "canceled" }, standalone: false, decls: 39, vars: 21, consts: [["confirmationModal", ""], [3, "closeModalHandler", "open", "requiresAction"], [3, "closeModalHandler", "header", "showCloseButton"], [1, "modal-body"], [1, "modal-section", "pt-10"], [1, "form-row", "custom-controls-stacked"], [1, "custom-control", "custom-radio"], ["type", "radio", "name", "conversion-mode", 1, "custom-control-input", 3, "click", "value", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "mt-2", "custom-control", "custom-checkbox"], ["type", "checkbox", "name", "create-copy", 1, "custom-control-input", 3, "click", "checked"], [1, "hr", "mt-1", "mb-3"], ["class", "collapse-header d-flex mb-2", 3, "ngClass", "click", 4, "ngIf"], ["class", "collapse bg-gray-base-95 pt-2", 3, "ngClass", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "errorText", "loading", "submitButtonText", "showCancelButton"], [3, "open", "requiresAction"], [3, "cancelHandler", "submitHandler", "submitButtonText"], [1, "collapse-header", "d-flex", "mb-2", 3, "click", "ngClass"], [1, "collapse-link"], [1, "collapse-chevron", "ml-1"], [1, "collapse", "bg-gray-base-95", "pt-2", 3, "ngClass"], [1, "max-height-230", "overflow-auto"], [1, "overflow-hidden"], [1, "row", "wide-gutters", "pl-1", "pr-1"], [1, "col-6"], [1, "mb-1", "text-bold"], [1, "pl-2"]], template: function ConvertModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function ConvertModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeConvertModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function ConvertModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeConvertModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "p");
        i0.ɵɵtext(5, " Some metrics and/or data in this feature are not included in your subscription. Choose one of the following: ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5)(7, "label", 6)(8, "input", 7);
        i0.ɵɵlistener("click", function ConvertModalComponent_Template_input_click_8_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setConversionMode(ctx.TRANSFORM)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "span", 8);
        i0.ɵɵelementStart(10, "span", 9);
        i0.ɵɵtext(11, "Use comparable metrics (where available)");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "label", 6)(13, "input", 7);
        i0.ɵɵlistener("click", function ConvertModalComponent_Template_input_click_13_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setConversionMode(ctx.FILTER)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "span", 8);
        i0.ɵɵelementStart(15, "span", 9);
        i0.ɵɵtext(16, "Remove all unavailable metrics");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(17, "label", 10)(18, "input", 11);
        i0.ɵɵlistener("click", function ConvertModalComponent_Template_input_click_18_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleCreateCopy()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "span", 8);
        i0.ɵɵelementStart(20, "span", 9);
        i0.ɵɵtext(21, "Create a copy");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(22, "hr", 12);
        i0.ɵɵtemplate(23, ConvertModalComponent_div_23_Template, 4, 4, "div", 13)(24, ConvertModalComponent_div_24_Template, 80, 3, "div", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(25, "ycn-simple-modal-footer", 15);
        i0.ɵɵlistener("cancelHandler", function ConvertModalComponent_Template_ycn_simple_modal_footer_cancelHandler_25_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeConvertModalHandler()); })("submitHandler", function ConvertModalComponent_Template_ycn_simple_modal_footer_submitHandler_25_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submitConvertModalHandler()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(26, "ycn-modal-base", 16, 0)(28, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function ConvertModalComponent_Template_ycn_simple_modal_header_closeModalHandler_28_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeConfirmationModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 3)(30, "div", 4)(31, "p");
        i0.ɵɵtext(32, "You are about to update an existing asset permanently. Are you sure you want to continue?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "label", 10)(34, "input", 11);
        i0.ɵɵlistener("click", function ConvertModalComponent_Template_input_click_34_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleCreateCopy()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(35, "span", 8);
        i0.ɵɵelementStart(36, "span", 9);
        i0.ɵɵtext(37, "Create a copy instead");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(38, "ycn-simple-modal-footer", 17);
        i0.ɵɵlistener("cancelHandler", function ConvertModalComponent_Template_ycn_simple_modal_footer_cancelHandler_38_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeConfirmationModalHandler()); })("submitHandler", function ConvertModalComponent_Template_ycn_simple_modal_footer_submitHandler_38_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submitConfirmationModalHandler()); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.convertModalOpen)("requiresAction", ctx.requiresAction);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Convert Saved Asset Data Sources")("showCloseButton", !ctx.requiresAction);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("value", ctx.TRANSFORM)("checked", ctx.conversionMode === ctx.TRANSFORM);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("value", ctx.FILTER)("checked", ctx.conversionMode === ctx.FILTER);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("checked", ctx.createCopy);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", false);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", false);
        i0.ɵɵadvance();
        i0.ɵɵproperty("errorText", ctx.error)("loading", ctx.loading)("submitButtonText", "OK")("showCancelButton", !ctx.requiresAction);
        i0.ɵɵadvance();
        i0.ɵɵproperty("open", ctx.confirmationModalOpen)("requiresAction", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("header", "Confirm Asset Overwrite")("showCloseButton", false);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("checked", ctx.createCopy);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("submitButtonText", "Continue");
    } }, dependencies: [i2.NgClass, i2.NgIf, i3.ModalBaseComponent, i4.SimpleModalFooterComponent, i5.SimpleModalHeaderComponent], encapsulation: 2 });
